export class Actividad {
    actividad;
    constructor() {
        this.actividad = "";
    }
}
